import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { identificationTypePatch } from "../../store/identificationType/actions";
export var useIdentificationTypePatch = function (trigger, bodyRequest) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePatchIdentificationType: (_a = state.IdentificationType.responsePatchIdentificationType) === null || _a === void 0 ? void 0 : _a.data,
            errorPatchIdentificationType: state.IdentificationType.errorPatchIdentificationType,
            loadingPatchIdentificationType: state.IdentificationType.loadingPatchIdentificationType,
        });
    }), responsePatchIdentificationType = _a.responsePatchIdentificationType, errorPatchIdentificationType = _a.errorPatchIdentificationType, loadingPatchIdentificationType = _a.loadingPatchIdentificationType;
    useEffect(function () {
        var _a;
        if (trigger) {
            dispatch(identificationTypePatch((_a = bodyRequest.data) === null || _a === void 0 ? void 0 : _a.id, bodyRequest));
        }
    }, [bodyRequest]);
    return {
        responsePatchIdentificationType: responsePatchIdentificationType,
        errorPatchIdentificationType: errorPatchIdentificationType,
        loadingPatchIdentificationType: loadingPatchIdentificationType,
    };
};
